export const getNow = () => {
	return new Date();
};
